<template>
<v-list-item
  @click='$emit("selected", item)' >
  <v-list-item-action v-if='withActions' >
    <v-menu >
      <template v-slot:activator="{ on }">
        <slot>
          <v-btn v-on='on' slot='activator' small icon >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </slot>
      </template>
      <appointment-type-action-list v-model='item' />
    </v-menu>
  </v-list-item-action>
  <v-list-item-action v-if='withDelete' >
    <v-dialog v-model="deletedialog" width="500" >
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon
          :disabled='item.archived'
          v-bind="attrs"
          v-on="on"
          color='error' >
          <v-icon>mdi-archive</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title  >
          Please confirm
        </v-card-title>
        <request-status :request='deleteRequest' />
        <v-card-text class='subtitle-1' >
          <p>Are you sure you want to delete or archive this apppointment type?</p>
          <p class='caption' >
            <v-icon small >mdi-information</v-icon>
            If this appointment type has no appointments it will be deleted.
            Otherwise it will be archived
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions >
          <v-btn text @click='deletedialog=false' >Cancel</v-btn>
          <v-spacer/>
          <v-btn
            :loading='deleteRequest.loading'
            @click='performDelete(item)'
            color='error' >Archive</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item-action>
  <v-list-item-content>
    <v-list-item-title >
      {{item.title}}
      <v-chip x-small outlined label >#{{item.id}}</v-chip>
      <v-chip color='warning' class='mx-2' x-small label v-if='item.archived' >Archived</v-chip>
      <v-chip color='info' class='mx-2' x-small label v-if='item.private' >Private</v-chip>
      <v-chip color='info' class='mx-2' label x-small v-if='item.is_online' >Virtual</v-chip>
      <v-chip color='info' class='mx-2' label x-small v-if='item.comes_to_you' >Flexible</v-chip>
      <v-chip
        title="This appointment type has automatic ICD-10 codes. The pricing for this appointment will be determined by the codes that are added"
        color='warning' class='mx-2' x-small label v-if='hasAutoCodes' >
        <v-icon x-small left >mdi-flash</v-icon>
      Automated</v-chip>
    </v-list-item-title>
    <v-list-item-subtitle >
      <strong v-if='practitionerName' >{{practitionerName}}.</strong>
      {{item.duration}} mins.
      <span v-if="item.discount && parseFloat(item.discount) > 0" >
        {{ formatCurrency(item.currency, item.price) }}
        <v-chip x-small label outlined color="success" class="ml-2" >
          Discount:
          {{ formatCurrency(item.currency, item.discount) }}
        </v-chip>
      </span>
      <span v-else >{{ formatCurrency(item.currency, item.price) }}</span>
    </v-list-item-subtitle>
    <v-list-item-subtitle >
      <!-- {{item}} -->
      <template v-if='item.locations && item.locations.length > 0' >
        <template v-for='loc in item.locations' >
          <location-chip class='mr-2'
            @selected='$emit("location:clicked", loc)'
            v-if='loc.id'
            :space-id='spaceId'
            :location-id='loc.id'
            :attrs="{xSmall: true}"
            :key='loc.id' />
          <location-chip
            v-else class='mr-2'
            @selected='$emit("location:clicked", loc)'
            :space-id='spaceId'
            :location-id='loc'
            :attrs="{xSmall: true}"
            :key='loc' />
        </template>
      </template>
      <v-chip x-small outlined
        @click.stop="editLocations(item)" >
        <v-icon x-small >mdi-pencil</v-icon> Edit locations</v-chip>
      <!-- <v-chip class='mr-1'

        :set="location=getLocationBySpaceAndId(item.service, loc)"
        :key='loc' x-small >
        <template v-if='location' >
          <v-icon x-small left >mdi-map-marker</v-icon>
          {{location.name}}
        </template>
      </v-chip> -->
    </v-list-item-subtitle>
  </v-list-item-content>
  <v-list-item-action v-if='withEdit' >
    <v-btn small outlined @click.prevent='$emit("edit", item)' >Edit</v-btn>
  </v-list-item-action>

  <v-dialog v-model="editlocationsdialog" width="300" >
    <v-card v-if="selectedProduct" >
      <request-status :request="locationRequest" @ok="$emit('input', selectedProduct);editlocationsdialog=false" />
      <v-card-title class='overline py-0 grey lighten-4' >
        Set locations
        <v-spacer />
        <v-btn @click="editlocationsdialog=false" icon small >
          <v-icon small >mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text class="py-3" >
        <location-picker multiple inline v-model="locations" :space-id="spaceId" />
      </v-card-text>
      <!-- <pre v-text="locations" class="caption" /> -->
      <v-card-actions >
        <v-spacer/>
        <v-btn @click="saveLocations"
          :loading="locationRequest.loading"
          color="primary" >Save</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</v-list-item>
</template>
<script>
import {mapGetters} from 'vuex'
import AppointmentTypeActionList from '@/components/actions/lists/AppointmentTypeActionList'
import LocationChip from '@/components/listitems/LocationChip.vue'
import LocationPicker from '@/components/pickers/LocationPicker.vue'

export default {
  name: 'AppointmentTypeListItem',
  components: {
    AppointmentTypeActionList,
    LocationChip,
    LocationPicker
  },
  props: {
    item: { type: Object, required: true },
    withEdit: { type: Boolean, default: true },
    withDelete: { type: Boolean, default: true },
    withActions: { type: Boolean, default: false }
  },
  data () {
    return {
      deletedialog: false,
      editlocationsdialog: false,
      deleteRequest: {
        // resource: 'ag.spaces.products'
        resource: 'ag.spaces.products.v3',
      },
      locationRequest: {
        resource: 'ag.spaces.appointmenttypes'
      },
      selectedProduct: null,
      locations: []
    }
  },
  computed: {
    ...mapGetters('identity', ['getPractitionerById', 'getLocationBySpaceAndId']),
    spaceId () {
      if (this.item.space) { return this.item.space }
      if (this.item.service) { return this.item.service }
      return ''
    },
    practitionerName () {
      let practitioner = null
      if (this.item && this.item.practitioner) {
        if (isNaN(this.item.practitioner)) {
          return `${this.item.practitioner.first_name} ${this.item.practitioner.last_name}`
        } else { // lookup on practitioner ID
          practitioner = this.getPractitionerById(this.item.practitioner)
          if (practitioner) {
            return practitioner.full_name
          }
        }
      }
      return null
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    },
    hasAutoCodes () {
      return (this.item && this.item.auto_codes && this.item.auto_codes.length > 0)
    }
  },
  watch: {
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.deletedialog = false
        this.$emit('reload')
      }
    },
    editlocationsdialog () {
      if (this.editlocationsdialog === false) {
        this.selectedProduct = null
      }
    }
  },
  methods: {
    performDelete (at) {
      this.deleteRequest.resourceId = at.id
      this.$request('delete', this.deleteRequest)
    },
    editLocations (at) {
      this.selectedProduct = at
      this.locations = at.locations
      this.editlocationsdialog = true
    },
    saveLocations () {
      let payload = {
        locations: this.locations
      }
      this.locationRequest.data = payload
      this.locationRequest.kwargs = {spaceId: this.spaceId}
      this.locationRequest.resourceId = this.selectedProduct.id
      this.$request('save', this.locationRequest)
    }
  }
}
</script>
